// ? NOTE: The currently(07/06/2022) preferred state management solution for this project is to use the default react useState hook where we can.
// ? However in some situations where it makes sense e.g. storing the location as this is passed through many components that wouldn't use it
// ? and use redux instead
// TODO: Is redux still needed? A potential refactor to default react state if not necessary.

export enum ActionTypes {
  UPDATE_LOCATION = 'UPDATE_LOCATION',
}
